export function safeConvertFixed(num: number, precision = 2) {
  return Number.isInteger(num) ? num : Number(num).toFixed(3)
}
